import React from "react";
import useTranslation from "next-translate/useTranslation";
import { errorCodes } from "@chesshotel/constants";
import styles from "./styles/RegisterError.module.css";

export default function RegisterError({ errorCode }) {
  const { t } = useTranslation("common");

  let error = "";

  switch (errorCode) {
    case errorCodes.ERROR_USERNAME_NOT_AVAILABLE:
      error = t("Username taken");
      break;

    case errorCodes.ERROR_USERNAME_TOO_SHORT:
      error = t("Username too short");
      break;

    case errorCodes.ERROR_USERNAME_TOO_LONG:
      error = t("Username too long");
      break;

    case errorCodes.ERROR_GENERAL:
      error = t("Something went wrong");
      break;

    case errorCodes.ERROR_EMAIL_NOT_VALID:
      error = t("Email not valid");
      break;

    case errorCodes.ERROR_EMAIL_NOT_AVAILABLE:
      error = t("Email not available");
      break;

    case errorCodes.ERROR_PASSWORD_TOO_SHORT:
      error = t("Password too short");
      break;

    case errorCodes.ERROR_PASSWORD_TOO_LONG:
      error = t("Password too long");
      break;

    case errorCodes.ERROR_PASSWORDS_DO_NOT_MATCH:
      error = t("Password fields don't match");
      break;

    case errorCodes.ERROR_NO_COUNTRY:
      error = t("No country selected");
      break;

    default:
      return null;
  }

  return <div className={styles.error}>{error}</div>;
}
